<template>
  <v-container fluid v-if="tiene_empresa">
    <v-data-table
      v-if="flag_csv == 'no'"
      :headers="headerTable1"
      :items="items"
      :search="search"
      dense
      :loading="loading_facturas"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="listarFacturas()" v-bind="attrs" v-on="on">
                fa-solid fa-rotate-right
              </v-icon>
            </template>
            <span>{{ $t("factura-table-top-tooltip1") }}</span>
          </v-tooltip>
          <v-divider class="mx-4" inset vertical></v-divider>
         
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        
          <v-btn color="primary" @click="nuevaFactura()">
            {{ $t("factura-table-top-btn3") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.fecha`]="{ item }">
        <span> {{ formatoFecha(item.fecha) }}</span>
      </template>

      <template v-slot:[`item.total_pagar`]="{ item }">
        <span> $ {{ Number(item.total_pagar).toFixed(2) }}</span>
      </template>

      <template v-slot:[`item.estatus`]="{ item }">
        <v-tooltip
          left
          color="primary"
          v-if="
            item.sello_recepcion == '' && item.resolucion_invalidacion == null
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on"
              >fa-regular fa-floppy-disk</v-icon
            >
          </template>
          <span>{{ $t("tooltip-status-t1") }}</span>
        </v-tooltip>

        <v-tooltip
          left
          color="success"
          v-else-if="
            item.sello_recepcion != '' && item.resolucion_invalidacion == null
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="success" v-bind="attrs" v-on="on"
              >fa-regular fa-circle-check</v-icon
            >
          </template>
          <span>{{ $t("tooltip-status-t2") }}</span>
        </v-tooltip>

        <v-tooltip
          left
          color="error"
          v-else-if="
            item.resolucion_invalidacion != '' &&
            item.resolucion_invalidacion != null
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on"
              >fa-solid fa-ban</v-icon
            >
          </template>
          <span>{{ $t("tooltip-status-t3") }}</span>
        </v-tooltip>

        <v-tooltip left color="error" v-else-if="item.estatus == 'ERROR'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on"
              >fa-solid fa-circle-exclamation</v-icon
            >
          </template>
          <span>{{ $t("tooltip-status-t4") }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon @click="editarFactura(item)">
          fa-solid fa-pen-to-square
        </v-icon>
      </template>

      <template v-slot:[`item.action_send_dte`]="{ item }">
        <v-icon @click="enviarDTE(item)" :disabled="item.sello_recepcion != ''">
          fa-regular fa-paper-plane
        </v-icon>
      </template>

      <template v-slot:[`item.action_view_dte`]="{ item }">
        <v-icon @click="vistaPreviaPdf(item)" v-if="item.sello_recepcion == ''">
          fa-regular fa-file-pdf
        </v-icon>
        <v-icon
          @click="vistaPreviaPdfSello(item)"
          v-else-if="item.sello_recepcion != ''"
        >
          fa-regular fa-file-pdf
        </v-icon>
      </template>

      <template v-slot:[`item.action_send_mail`]="{ item }">
        <v-icon
          @click="reenviarCorreo(item)"
          :disabled="item.sello_recepcion == ''"
        >
          fa-regular fa-envelope
        </v-icon>
      </template>
    </v-data-table>

    <v-data-table
      v-if="flag_csv == 'si'"
      :headers="headerTable5"
      :items="items_csv"
    >
      <template v-slot:top>
        <v-row>
          <v-col cols="4">
            <v-file-input
              v-model="data_file_input"
              :label="$t('factura-table-top-fileinput1')"
              outlined
              dense
              hide-details
              multiple
              @change="procesarCSVNuevo"
              :loading="loading_guardar"
            ></v-file-input>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              @click="guardarCSV()"
              :loading="loading_guardar"
              >{{ $t("btn-save") }}</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn color="grey" dark @click="flag_csv = 'no'">{{
              $t("btn-back")
            }}</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent width="3000" scrollable>
      <v-card>
        <v-card-text>
          <!-- PRIMERA PARTE CORRELATIVOS-->
          <v-card class="mx-8 my-2">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="6" class="pa-1">
                  <v-text-field
                    v-model="numero_control"
                    :label="$t('factura-dialog-input-label1')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-1">
                  <v-text-field
                    v-model="codigo_generacion"
                    :label="$t('factura-dialog-input-label2')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-1">
                  <v-text-field
                    v-model="fecha_hora"
                    :label="$t('factura-dialog-input-label3')"
                    type="datetime-local"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field
                    v-model="sello_recepcion"
                    :label="$t('factura-dialog-input-label4')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field
                    v-model="fecha_recepcion"
                    :label="$t('factura-dialog-input-label5')"
                    type="datetime-local"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- SEGUNDA PARTE SUCARSAL, TIPO DOC-->
          <v-card class="mx-8 mb-2">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="6" class="pa-1">
                  <v-autocomplete
                    v-model="sucursal"
                    :items="items_sucursales"
                    item-text="nombre"
                    item-value="id_sucursal"
                    :label="$t('factura-dialog-input-label6')"
                    auto-select-first
                    outlined
                    dense
                    hide-details
                    @input="listarTipoDocs(), listarPuntosVenta('manual')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="pa-1">
                  <v-autocomplete
                    v-model="punto_venta"
                    :items="items_punto_venta"
                    item-text="descripcion"
                    item-value="id_punto_venta"
                    :label="$t('factura-dialog-input-label7')"
                    outlined
                    dense
                    hide-details
                    @input="listarTipoDocs()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" class="pa-1">
                  <v-autocomplete
                    v-model="tipo_doc_fiscal"
                    :items="items_tipo_doc_fiscales"
                    item-text="nombre_doc_fiscal"
                    item-value="id_tipo_doc_fiscal"
                    :label="$t('factura-dialog-input-label8')"
                    outlined
                    dense
                    hide-details
                    return-object
                    @change="listarTipoDocs()"
                    @input="listarDocSeleccionado()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" align-self="center">
                  <v-btn
                    block
                    @click="listarCCF()"
                    :disabled="
                      tipo_doc_fiscal.cod_doc_fiscal != 'NCR' &&
                      tipo_doc_fiscal.cod_doc_fiscal != 'NDB'
                    "
                  >
                    <v-icon left>fa-solid fa-file-invoice-dollar</v-icon>
                    {{ $t("factura-dialog-btn1") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-autocomplete
                    v-model="tipo_pago"
                    :items="items_tipo_pago"
                    :label="$t('factura-dialog-input-label9')"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-autocomplete
                    v-model="metodo_pago"
                    :items="items_metodo_pago"
                    :label="$t('factura-dialog-input-label10')"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- TERCERA PARTE CLIENTE-->
          <v-card class="mx-8 mb-2">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="5" class="pa-1">
                  <v-autocomplete
                    v-model="cliente"
                    :items="items_clientes"
                    item-text="nombre"
                    item-value="codigo"
                    :label="$t('factura-dialog-label11')"
                    outlined
                    dense
                    hide-details
                    return-object
                    @input="setCliente()"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.codigo }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.codigo }} {{ data.item.nombre }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field
                    v-model="registro"
                    :label="$t('factura-dialog-label12')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field
                    v-model="identifiador"
                    :label="$t('factura-dialog-label13')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field
                    v-model="telefono"
                    :label="$t('factura-dialog-label14')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="7" class="pa-1">
                  <v-text-field
                    v-model="nombre"
                    :label="$t('factura-dialog-label15')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field
                    v-model="tipo"
                    :label="$t('factura-dialog-label16')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field
                    v-model="num_documento"
                    :label="$t('factura-dialog-label17')"
                    outlined
                    dense
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- TABLA SERVICIOS -->
          <v-card class="mx-8 mb-2">
            <v-card-text>
              <v-data-table
                :headers="headerTable2"
                :items="items_productos"
                dense
              >
                <template v-slot:top>
                  <v-row justify="space-around" align="center">
                    <v-col cols="12" md="1" class="px-1">
                      <v-text-field
                        v-model="cantidad"
                        :label="$t('factura-dialog-label18')"
                        outlined
                        dense
                        hide-details
                        type="number"
                        :disabled="tipo_doc_fiscal == ''"
                        @input="calculoCantidad"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="px-1">
                      <v-text-field
                        v-model="producto"
                        :label="$t('factura-dialog-label19')"
                        outlined
                        dense
                        hide-details
                        :disabled="cantidad <= 0 || tipo_doc_fiscal == ''"
                        @input="asignarProducto()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="auto" md="auto" class="px-1">
                      <v-btn
                        outlined
                        @click="dialog_servicios = true"
                        :disabled="tipo_doc_fiscal == ''"
                      >
                        <v-icon>fa-solid fa-magnifying-glass</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="px-1">
                      <v-text-field
                        v-model="descripcion"
                        :label="$t('factura-dialog-label20')"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="px-1">
                      <v-text-field
                        v-model="precio"
                        :label="$t('factura-dialog-label22')"
                        outlined
                        dense
                        hide-details
                        type="number"
                        :disabled="descripcion == ''"
                        @change="modificarPrecio()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="px-1">
                      <v-text-field
                        v-model="descuento_prod"
                        :label="$t('factura-dialog-label23')"
                        outlined
                        dense
                        hide-details
                        type="number"
                        :disabled="descripcion == ''"
                        @change="calculoDescuento()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="px-1">
                      <v-text-field
                        v-model="total"
                        :label="$t('factura-dialog-label24')"
                        outlined
                        dense
                        hide-details
                        type="number"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="auto" md="auto" class="px-1">
                      <v-btn
                        @click="agregarProducto()"
                        :disabled="sello_recepcion != ''"
                      >
                        <v-icon color="green">fa-solid fa-square-check</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>

                <template v-slot:[`item.descripcion`]="{ item }">
                  <span>
                    {{
                      item.descripcion +
                      " " +
                      (item.comp_pedido != null ? item.comp_pedido : "")
                    }}</span
                  >
                </template>

                <template v-slot:[`item.precio`]="{ item }">
                  <span> $ {{ Number(item.precio).toFixed(2) }}</span>
                </template>

                <template v-slot:[`item.descuento`]="{ item }">
                  <span> % {{ Number(item.descuento).toFixed(2) }}</span>
                </template>

                <template v-slot:[`item.total`]="{ item }">
                  <span> $ {{ Number(item.total).toFixed(2) }}</span>
                </template>

                <template v-slot:[`item.action_edit`]="{ item }">
                  <v-icon
                    @click="editarProducto(item)"
                    :disabled="sello_recepcion != ''"
                  >
                    fa-solid fa-pen-to-square
                  </v-icon>
                </template>

                <template v-slot:[`item.action_delete`]="{ item }">
                  <v-icon
                    class="mr-2"
                    @click="eliminarDetalleFactura(item)"
                    :disabled="sello_recepcion != ''"
                  >
                    fa-solid fa-trash-can
                  </v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <!-- ULTIMA PARTE CALCULOS-->
          <v-row no-gutters justify="center" align="center" class="mx-8">
            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field
                  v-model="otros_cargos"
                  :label="$t('factura-dialog-label-25')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="anticipo"
                  :label="$t('factura-dialog-label-26')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
            </v-card>
            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field
                  v-model="calculoSubTotal"
                  :label="$t('factura-dialog-label-27')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="descuento"
                  :label="$t('factura-dialog-label-28')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  :readonly="flag_descuento"
                ></v-text-field>
              </v-col>
            </v-card>
            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field
                  v-model="gravadas"
                  :label="$t('factura-dialog-label-29')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="iva"
                  :label="$t('factura-dialog-label-30')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
            </v-card>
            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field
                  v-model="exentas"
                  :label="$t('factura-dialog-label-31')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="no_sujetas"
                  :label="$t('factura-dialog-label-32')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
            </v-card>
            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field
                  v-model="calculoRetencion"
                  :label="$t('factura-dialog-label-33')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="percepcion"
                  :label="$t('factura-dialog-label-34')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
            </v-card>
            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field
                  v-model="calculoTotalOperacion"
                  :label="$t('factura-dialog-label-35')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="calculoTotalPagar"
                  :label="$t('factura-dialog-label-36')"
                  prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
            </v-card>
          </v-row>
        </v-card-text>

        <v-card-actions style="background-color: white">
          <v-btn
            color="primary"
            @click="crearfactura()"
            v-if="flag_new_edit == 1"
            :loading="loading_guardar"
            >{{ $t("btn-save") }}</v-btn
          >
          <v-btn
            color="primary"
            @click="actualizarfactura()"
            v-if="flag_new_edit == 2"
            :disabled="sello_recepcion != ''"
            >{{ $t("btn-update") }}</v-btn
          >
          <v-btn
            color="red"
            @click="confirmarAnularDocumento()"
            v-if="
              flag_new_edit == 2 &&
              ($store.state.usuario.rol == 'Administrador' || $store.state.usuario.rol == 'IT') &&
              sello_recepcion != '' &&
              resolucion_invalidacion == null
            "
            :disabled="sello_recepcion == ''"
            >{{ $t("btn-cancel") }}</v-btn
          >
          <v-btn
            color="red"
            @click="eliminarFactura()"
            v-if="
              flag_new_edit === 2 &&
              ($store.state.usuario.rol === 'Administrador' ||
                $store.state.usuario.rol === 'IT') &&
              sello_recepcion === ''
            "
            :loading="loading_eliminar_factura"
            dark
            >{{ $t("btn-delete") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog">{{ $t("btn-close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_clientes">
      <v-data-table
        :headers="headers_clientes"
        :items="items_clientes"
        @dblclick:row="setCliente"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Clientes</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <div style="color: black">[Hacer doble click para seleccionar]</div>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="dialog_servicios">
      <v-data-table
        :headers="headerTable6"
        :items="items_servicios"
        @dblclick:row="setServicio"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{
              $t("factura-dialog-table3-top-t1")
            }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <div style="color: black">
              {{ $t("factura-dialog-table3-top-t2") }}
            </div>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_servicio" width="500">
      <v-card>
        <v-card-title>{{ $t("message-t1") }}</v-card-title>
        <v-card-actions>
          <v-btn color="red" dark @click="confirmarEliminarDetalleFactura()">{{
            $t("btn-delete")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar_servicio = false">{{
            $t("btn-close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_tabla_CCF" width="1500" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <v-data-table
            v-model="items_tipo_doc_ncr_ndb"
            :headers="headerTable3"
            :items="items_ccf"
            :search="search_ccf"
            :item-class="colorTablaCCF"
            :show-select="tipo_doc_fiscal.cod_doc_fiscal == 'NDB'"
            item-key="id_factura"
            single-select
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{ $t("invoice-plural") }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search_ccf"
                  :label="$t('search')"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template
              v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
            >
              <v-simple-checkbox
                :value="isSelected"
                :disabled="fechaLimiteDebitoCredito(item)"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-button @click="testCheck(item)"> Edit </v-button>
            </template>

            <template v-slot:[`item.action_add_servicio`]="{ item }">
              <v-btn
                v-if="tipo_doc_fiscal.cod_doc_fiscal == 'NCR'"
                icon
                @click="listarServiciosDocNCR(item)"
                elevation="3"
                color="black"
              >
                <v-icon>fa-solid fa-check</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.fecha`]="{ item }">
              <span>{{ formatoFecha(item.fecha) }}</span>
            </template>

            <template v-slot:[`item.gravadas`]="{ item }">
              <span> $ {{ item.gravadas.toFixed(2) }}</span>
            </template>

            <template v-slot:[`item.iva`]="{ item }">
              <span> $ {{ item.iva.toFixed(2) }}</span>
            </template>

            <template v-slot:[`item.total_pagar`]="{ item }">
              <span> $ {{ item.total_pagar.toFixed(2) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_tabla_CCF = false">{{
            $t("btn-close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_tabla_detalles_fac" width="1500" persistent>
      <v-card>
        <v-data-table
          v-model="items_productos"
          :headers="headerTable4"
          :items="items_detalles_fac"
          :search="search_detalles_fac"
          item-key="id_detalle_factura"
          show-select
          :item-class="colorTablaDetalles"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t("details-invoice") }}</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search_detalles_fac"
                :label="$t('search')"
                outlined
                dense
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>

          <template v-slot:[`item.precio`]="{ item }">
            <span> $ {{ item.precio.toFixed(2) }}</span>
          </template>

          <template v-slot:[`item.descuento`]="{ item }">
            <span> % {{ item.descuento.toFixed(2) }}</span>
          </template>

          <template v-slot:[`item.total`]="{ item }">
            <span> $ {{ item.total.toFixed(2) }}</span>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-btn color="primary" @click="agregarServiciosDocNCR()">{{
            $t("btn-apply")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirmar_anular" width="500">
      <v-card>
        <v-card-title>{{ $t("message-t2") }}</v-card-title>
        <v-card-actions>
          <v-btn color="red" @click="anularFactura()">{{
            $t("btn-confirm")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="dialog_confirmar_anular = !dialog_confirmar_anular">{{
            $t("btn-close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_preview_report" fullscreen persistent>
      <v-toolbar flat dense>
        <v-toolbar-title> DOCUMENTO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="dialog_preview_report = !dialog_preview_report"
          >far fa-times-circle</v-icon
        >
      </v-toolbar>
      <iframe :src="base64_doc" id="myPDF" frameborder="0" />
    </v-dialog>

    <v-dialog v-model="dialog_enviar_todo_dte" width="600" persistent>
      <v-card>
        <v-card-title>{{ $t("message-t3") }}</v-card-title>
        <v-card-text class="subtitle-1">
          {{ $t("mesagge-t4") }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            :loading="loading_enviar_todo"
            @click="enviarTodoDTE()"
            >{{ $t("btn-send-all") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog_enviar_todo_dte = !dialog_enviar_todo_dte"
            >{{ $t("btn-close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_factura" width="500">
      <v-card>
        <v-card-title
          >{{ $t("message-t1") }} <br />
          {{ numero_control }}?</v-card-title
        >
        <v-card-actions>
          <v-btn color="red" dark @click="confirmarEliminarFactura()">{{
            $t("btn-delete")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar_factura = false">{{
            $t("btn-close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="-1"
      color="blue"
      multi-line
      elevation="24"
      outlined
      top
      right
    >
      <v-icon>{{ icon_snackbar }}</v-icon>
      {{ snackbar_text }}

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar = false">
          <v-icon>fa-regular fa-circle-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import settings from "@/settings/settings";
import axios from "axios";
import Papa from "papaparse";

export default {
  data: () => ({
    items_csv: [],
    flag_csv: "no",
    data_file_input: [],
    result_data_facturas: [],
    ////////////////////////////////////////////////////////////////////
    loading_guardar: false,
    snackbar: false,
    snackbar_text: "...",
    icon_snackbar: "fa-solid fa-circle-info",
    empresa: "OTROS",
    search: "",
    dialog: false,
    dialog_clientes: false,
    items: [],
    id_factura: 0,
    id_empresa: 0,
    id_tipo_doc_fiscal: 0,
    dialog_eliminar_servicio: false,
    extingido_cautelado: false,
    codigo_bien: "",
    //CLIENTES
    id_cliente: 0,
    headers_clientes: [
      { text: "Cliente", value: "codigo", sorteable: false },
      { text: "Nombre", value: "nombre", sorteable: false },
      { text: "Registro", value: "registro", sorteable: false },
      {
        text: "Identificador",
        value: "identificador_nombre",
        sorteable: false,
      },
      { text: "Teléfono", value: "telefono", sorteable: false },
      { text: "Tipo", value: "tipo_persona", sorteable: false },
    ],
    items_clientes: [],
    cliente_exento: false,
    cliente_retencion: false,
    cliente_percepcion: false,
    cliente_tamaño: "",
    cliente_extranjero: false,
    //DTE-00-00000000-000000000000000
    numero_control: "DTE-00-00000000-000000000000000",
    codigo_generacion: "",
    fecha_hora: "",
    sello_recepcion: "",
    fecha_recepcion: "",
    cliente: "",
    nombre: "",
    registro: "",
    identifiador: "",
    telefono: "",
    tipo: "",
    num_documento: "",
    consignado_a: "",
    tipo_doc_fiscal: "",
    items_tipo_doc_fiscales: [],
    tipo_pago: "CONTADO",
    items_tipo_pago: ["CONTADO", "CREDITO"],
    contador_tipo_doc_fiscal: 0,
    sello_invalidacion: "",
    resolucion_invalidacion: "",
    //SUCURSAL
    sucursal: "",
    items_sucursales: [],
    punto_venta: "",
    items_punto_venta: [],
    cod_sucursal_mh: "",
    cod_punto_venta_mh: "",
    //IDENTIFICADORES
    items_identificador: [],
    //TABLA PRODUCTO
    items_productos: [],
    cantidad: 1,
    producto: "",
    descripcion: "",
    precio: 0,
    descuento_prod: 0,
    monto_descuento: 0,
    total: 0,
    exento_prod: false,
    no_sujeto_prod: false,
    id_detalle_factura: 0,
    cont_prod: 0,
    id: 0,
    item_servicio_eliminar: "",
    metodo_pago: "EFECTIVO",
    items_metodo_pago: ["EFECTIVO", "TARJETA", "TRANSFERENCIA"],
    comprovante_pedido: "",
    //CALCULO DE VALORES
    otros_cargos: 0.0,
    anticipo: 0.0,
    sub_total: 0.0,
    descuento: 0.0,
    gravadas: 0.0,
    iva: 0.0,
    exentas: 0.0,
    no_sujetas: 0.0,
    retencion: 0.0,
    percepcion: 0.0,
    total_operacion: 0.0,
    total_pagar: 0.0,
    flag_descuento: false,
    flag_new_edit: 1,
    //TABLA CCF
    dialog_tabla_CCF: false,
    search_ccf: "",
    items_ccf: [],
    //TABLA DETALLES FACTURA
    dialog_tabla_detalles_fac: false,
    search_detalles_fac: "",
    items_detalles_fac: [],
    //DOCUMENTO NCR
    items_tipo_doc_ncr_ndb: [],
    lista_nrc_ndb_guardados: [],
    //SERVICIOS
    dialog_servicios: false,
    items_servicios: [],
    flag_servicio: true,
    dialog_confirmar_anular: false,
    dialog_preview_report: false,
    base64_doc: "",
    loading_facturas: false,
    tipo_archivo_csv: "1",
    loading_enviar_todo: false,
    dialog_enviar_todo_dte: false,
    dialog_eliminar_factura: false,
    loading_eliminar_factura: false,
  }),
  created() {
    //Especial para FEX
    if (this.flag_csv == "si") {
      this.obtenerCorrelativoTipoDocCSV(12);
    }
  },
  computed: {
    tiene_empresa() {
      if (this.$store.state.emp) {
        this.listarFacturas();
        this.listarUsuarioSucursal();
        this.listarSucursales();
        this.listarClientes();
        this.listarServicios();
        return true;
      } else {
        return false;
      }
    },
    calculoSubTotal() {
      this.sub_total = (
        Number(this.gravadas) +
        Number(this.exentas) +
        Number(this.no_sujetas)
      ).toFixed(2);
      return this.sub_total;
    },
    calculoRetencion() {
      if (this.tipo_doc_fiscal.cod_doc_fiscal == "FAC") {
        if (this.cliente_retencion) {
          if (this.gravadas >= 100) {
            this.retencion = ((this.gravadas / 1.13) * 0.01).toFixed(2);
          }
        }
      } else {
        if (this.cliente_retencion) {
          if (this.gravadas >= 100) {
            this.retencion = (Number(this.gravadas) * Number(0.01)).toFixed(2);
          }
        }
      }
      return this.retencion;
    },
    calculoCantidad() {
      this.total = (Number(this.cantidad) * Number(this.precio)).toFixed(2);
    },
    calculoTotalOperacion() {
      if (this.tipo_doc_fiscal.cod_doc_fiscal == "NCR") {
        this.total_operacion = (
          Number(this.gravadas) +
          Number(this.iva) -
          Number(this.retencion)
        ).toFixed(2);
        return this.total_operacion;
      }
      if (
        this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
        this.tipo_doc_fiscal.cod_doc_fiscal == "FAC"
      ) {
        this.total_operacion = (
          Number(this.gravadas) +
          Number(this.iva) +
          Number(this.exentas)
        ).toFixed(2);
        return this.total_operacion;
      }

      this.total_operacion = (
        Number(this.gravadas) +
        Number(this.iva) -
        Number(this.retencion) +
        Number(this.percepcion) +
        Number(this.exentas) +
        Number(this.no_sujetas)
      ).toFixed(2);
      return this.total_operacion;
    },
    calculoTotalPagar() {
      this.total_pagar = (
        Number(this.gravadas) +
        Number(this.iva) -
        Number(this.retencion) +
        Number(this.percepcion) +
        Number(this.exentas) +
        Number(this.no_sujetas) +
        Number(this.otros_cargos) -
        Number(this.anticipo)
      ).toFixed(2);
      return this.total_pagar;
    },
    headerTable1() {
      return [
        { text: this.$t("factura-table-header-t1"), value: "numero_control" },
        {
          text: this.$t("factura-table-header-t2"),
          value: "fecha",
          width: "150",
          sortable: false,
        },
        {
          text: this.$t("factura-table-header-t3"),
          value: "cod_doc_fiscal",
          width: "90",
          align: "center",
          sortable: false,
        },
        { text: this.$t("factura-table-header-t4"), value: "cliente_nombre" },
        {
          text: this.$t("factura-table-header-t5"),
          value: "total_pagar",
          align: "center",
          width: "100",
          sortable: false,
        },
        {
          text: this.$t("factura-table-header-t6"),
          value: "estatus",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("factura-table-header-t7"),
          value: "action_send_dte",
          align: "center",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("factura-table-header-t8"),
          value: "action_view_dte",
          align: "center",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("factura-table-header-t9"),
          value: "action_send_mail",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("factura-table-header-t10"),
          value: "action_edit",
          align: "center",
          align: "center",
          width: "80",
          sortable: false,
        },
      ];
    },
    headerTable2() {
      return [
        { text: this.$t("factura-dialog-table1-header-t1"), value: "cantidad" },
        {
          text: this.$t("factura-dialog-table1-header-t2"),
          value: "cod_servicio",
        },
        {
          text: this.$t("factura-dialog-table1-header-t3"),
          value: "descripcion",
        },
        { text: this.$t("factura-dialog-table1-header-t4"), value: "precio" },
        {
          text: this.$t("factura-dialog-table1-header-t5"),
          value: "descuento",
        },
        { text: this.$t("factura-dialog-table1-header-t6"), value: "total" },
        {
          text: this.$t("factura-dialog-table1-header-t7"),
          value: "action_edit",
        },
        {
          text: this.$t("factura-dialog-table1-header-t8"),
          value: "action_delete",
        },
      ];
    },
    headerTable3() {
      return [
        {
          text: this.$t("factura-dialog-table2-header-t1"),
          value: "action_add_servicio",
        },
        {
          text: this.$t("factura-dialog-table2-header-t2"),
          value: "numero_control",
        },
        { text: this.$t("factura-dialog-table2-header-t3"), value: "fecha" },
        {
          text: this.$t("factura-dialog-table2-header-t4"),
          value: "tipo_documento_nombre",
        },
        {
          text: this.$t("factura-dialog-table2-header-t5"),
          value: "cliente_codigo",
        },
        {
          text: this.$t("factura-dialog-table2-header-t6"),
          value: "cliente_nombre",
        },
        { text: this.$t("factura-dialog-table2-header-t7"), value: "gravadas" },
        { text: this.$t("factura-dialog-table2-header-t8"), value: "iva" },
        {
          text: this.$t("factura-dialog-table2-header-t9"),
          value: "total_pagar",
        },
      ];
    },
    headerTable4() {
      return [
        { text: this.$t("factura-dialog-table1-header-t1"), value: "cantidad" },
        {
          text: this.$t("factura-dialog-table1-header-t3"),
          value: "descripcion",
        },
        { text: this.$t("factura-dialog-table1-header-t4"), value: "precio" },
        {
          text: this.$t("factura-dialog-table1-header-t5"),
          value: "descuento",
        },
        { text: this.$t("factura-dialog-table1-header-t6"), value: "total" },
      ];
    },
    headerTable5() {
      return [
        {
          text: this.$t("factura-table-header-t1"),
          value: "encabezado.numero_control",
        },
        { text: this.$t("factura-table-header-t2"), value: "encabezado.fecha" },
        {
          text: this.$t("factura-table-header-t4"),
          value: "encabezado.Customer",
        },
        {
          text: this.$t("factura-table-header-t5"),
          value: "encabezado.total_pagar",
        },
      ];
    },
    headerTable6() {
      return [
        {
          text: this.$t("factura-dialog-table3-header-t1"),
          value: "cod_servicio",
        },
        {
          text: this.$t("factura-dialog-table3-header-t2"),
          value: "nom_servicio",
        },
        { text: this.$t("factura-dialog-table3-header-t3"), value: "precio" },
      ];
    },
  },
  methods: {
    async obtenerAmbiente() {
      return (
        await axios.get(
          "api/DetallesEmpresas/ObtenerAmbiente/" +
            this.$store.state.emp.id_empresa
        )
      ).data;
    },
    calculoIvaCSV(tipo_doc_fiscal, v_gravadas) {
      if (
        tipo_doc_fiscal == "CCF" ||
        tipo_doc_fiscal == "NCR" ||
        tipo_doc_fiscal == "NDB" ||
        tipo_doc_fiscal == "NRM"
      ) {
        return parseFloat(Number(v_gravadas) * Number(0.13)).toFixed(2);
      } else {
        return 0.0;
      }
    },
    calculoRetencionCSV(tipo_doc_fiscal, cliente_retencion, gravadas) {
      if (tipo_doc_fiscal == "FAC") {
        if (cliente_retencion) {
          if (Number(gravadas) >= 100) {
            return ((Number(gravadas) / 1.13) * 0.01).toFixed(2);
          } else {
            return 0.0;
          }
        } else {
          return 0.0;
        }
      } else {
        if (cliente_retencion) {
          if (Number(gravadas) >= 100) {
            return (Number(gravadas) * Number(0.01)).toFixed(2);
          } else {
            return 0.0;
          }
        } else {
          return 0.0;
        }
      }
    },
    calculoPercepcionCSV(tipo_doc_fiscal, cliente_percepcion, gravadas) {
      if (tipo_doc_fiscal != "FEX") {
        if (cliente_percepcion) {
          if (Number(gravadas) >= 100) {
            return (Number(gravadas) * Number(0.01)).toFixed(2);
          } else {
            return 0.0;
          }
        } else {
          return 0.0;
        }
      } else {
        return 0.0;
      }
    },
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    facturasCSV() {
      this.flag_csv = "si";
    },
    async procesarCSVNuevo() {
      if (this.data_file_input.length > 0) {
        this.loading_guardar = true;
        this.result_data_facturas = [];
        var flag_index = 0;
        var cont = 0;
        var id_doc_fiscal = null;
        var cont_detalle = 0;
        for (var i = 0; i < this.data_file_input.length; i++) {
          await Papa.parse(this.data_file_input[i], {
            header: true,
            skipEmptyLines: true,
            quoteChar: '"',
            escapeChar: '"',
            complete: async (results) => {
              //console.log(results.data);
              for (var a = 0; a < results.data.length; a++) {
                id_doc_fiscal = await this.obtenerTipoDocCsv("01");
                //console.log(id_doc_fiscal);
                await this.obtenerClienteDocCsv(
                  results.data[a]["Order ID"] + "-" + new Date().getFullYear(), //documento
                  results.data[a]["Name"], //nom_cliente
                  "El Salvador", //direccion_cliente
                  results.data[a]["Email"], //correo_cliente
                  0, //extranjero
                  "01", //tipo_exportacion
                  9363, //pais
                  "01", //tipo_doc_fiscal
                  "" //registro
                ).then(async (res) => {
                  //console.log("id_cliente", res);
                  //if (results.data[a][0] != "") {
                  var num_control =
                    (await this.obtenerCorrelativoTipoDocCSV(
                      id_doc_fiscal.id_tipo_doc_fiscal
                    )) + cont_detalle;

                  this.contador_tipo_doc_fiscal = num_control;
                  var formato_ceros = "000000000000000".substring(
                    0,
                    15 - num_control.toString().length
                  );

                  flag_index = cont++;
                  this.result_data_facturas.push({
                    encabezado: {
                      id_tipo_doc_fiscal: await this.obtenerTipoDocCsv(
                        "01"
                      ).then((x) => {
                        return x.id_tipo_doc_fiscal;
                      }),
                      id_cliente: res[0] == undefined ? res : res[0].id_cliente,
                      id_empresa: this.$store.state.emp.id_empresa,
                      id_sucursal: await this.obtenerSucursalCsv("M001"),
                      numero_control:
                        "DTE-" +
                        id_doc_fiscal.cod_mh +
                        "-00000000-" +
                        formato_ceros +
                        num_control,
                      codigo_generacion: await this.obtenerGuidCSV(),
                      fecha: settings.metodos.formatoFechaHora(new Date()),
                      sello_recepcion: "",
                      fecha_recepcion: "",
                      anticipo: 0,
                      exentas: 0,
                      no_sujetas: 0,
                      otros_cargos: 0,
                      percepcion: 0.0,
                      retencion: 0.0,
                      iva: 0.0,
                      sub_total: Number(results.data[a]["Net Amt."]).toFixed(2),
                      cod_cliente: "",
                      Customer: "",
                      NIT: "",
                      LineofBusiness: "",
                      Country: "",
                      Address: "",
                      ciudad: "",
                      estado: "",
                      Phonenumber: "",
                      correo1: results.data[a]["Email"],
                      correo2: "",
                      correo3: "",
                      consignado_a: "",
                      consignado_a_direccion: "",
                      descuento: 0.0,
                      seguro: 0.0,
                      transporte: 0.0,
                      total_pagar: Number(results.data[a]["Net Amt."]).toFixed(
                        2
                      ),
                      tipo_pago: "CONTADO",
                      incoterms: "",
                      comentario: "",
                      referencia: "",
                      sample_charge: 0.0,
                      otros: 0.0,
                      efficiency_surcharge: 0.0,
                      light_weight_charge_money: 0.0,
                      bags_per_piece: "",
                      pais_origen: "",
                      total_pounds: 0.0,
                      gross_weight: "",
                      raw_material: 0.0,
                      added_value: 0.0,
                      customs_total: 0.0,
                      gravadas: Number(results.data[a]["Net Amt."]).toFixed(2),
                      total_operacion: Number(
                        results.data[a]["Net Amt."]
                      ).toFixed(2),
                      estatus: "GUARDADO",
                      es_anulado: false,
                      metodo_pago: "Pago Digital",
                    },
                    detalles: [
                      {
                        cod_servicio: "01",
                        descuento: Number(
                          results.data[a]["Total Discount Amt."]
                        ),
                        estilo: "",
                        cantidad: results.data[a]["Items"],
                        unidad_medida: "",
                        descripcion: "PRODUCTOS SEGUN COMPROBANTES DE PEDIDO #",
                        comp_pedido: results.data[a]["Order ID"],
                        descripcion2: "",
                        precio: (
                          (Number(results.data[a]["Gross Amt."]) +
                            Number(results.data[a]["Total Tax Amt."])) /
                          Number(results.data[a]["Items"])
                        ).toFixed(2),
                        total: Number(results.data[a]["Net Amt."]).toFixed(2),
                      },
                    ],
                  });
                  cont_detalle++;
                });
              }
            },
          });
        }
        //console.log(this.result_data_facturas);
        this.loading_guardar = false;
        this.items_csv = this.result_data_facturas;
      }
    },
    async procesarCSV() {
      if (this.data_file_input.length > 0) {
        this.loading_guardar = true;
        this.result_data_facturas = [];
        var flag_index = 0;
        var cont = 0;
        var id_doc_fiscal = null;
        var cont_detalle = 0;
        for (var i = 0; i < this.data_file_input.length; i++) {
          await Papa.parse(this.data_file_input[i], {
            header: false,
            //dynamicTyping: true,
            skipEmptyLines: true,
            complete: async (results) => {
              //console.log(results.data);
              for (var a = 0; a < results.data.length; a++) {
                id_doc_fiscal =
                  results.data[a][0] != ""
                    ? await this.obtenerTipoDocCsv(results.data[a][0])
                    : id_doc_fiscal;
                //console.log(id_doc_fiscal);
                await this.obtenerClienteDocCsv(
                  results.data[a][11], //documento
                  results.data[a][13], //nom_cliente
                  results.data[a][16], //direccion_cliente
                  results.data[a][23], //correo_cliente
                  results.data[a][20], //extranjero
                  results.data[a][21], //tipo_exportacion
                  results.data[a][22], //pais
                  results.data[a][0], //tipo_doc_fiscal
                  results.data[a][12] //registro
                ).then(async (res) => {
                  //console.log("id_cliente", res);
                  if (results.data[a][0] != "") {
                    var num_control =
                      (await this.obtenerCorrelativoTipoDocCSV(
                        id_doc_fiscal.id_tipo_doc_fiscal
                      )) + cont_detalle;

                    this.contador_tipo_doc_fiscal = num_control;
                    var formato_ceros = "000000000000000".substring(
                      0,
                      15 - num_control.toString().length
                    );

                    flag_index = cont++;
                    this.result_data_facturas.push({
                      encabezado: {
                        id_tipo_doc_fiscal: await this.obtenerTipoDocCsv(
                          results.data[a][0]
                        ).then((x) => {
                          return x.id_tipo_doc_fiscal;
                        }),
                        id_cliente:
                          res[0] == undefined ? res : res[0].id_cliente,
                        id_empresa: this.$store.state.emp.id_empresa,
                        id_sucursal: await this.obtenerSucursalCsv(
                          results.data[a][9]
                        ),
                        numero_control:
                          "DTE-" +
                          id_doc_fiscal.cod_mh +
                          "-00000000-" +
                          formato_ceros +
                          num_control,
                        codigo_generacion: await this.obtenerGuidCSV(),
                        fecha: settings.metodos.formatoFechaHora(new Date()),
                        sello_recepcion: "",
                        fecha_recepcion: "",
                        anticipo: 0,
                        exentas: 0,
                        no_sujetas: 0,
                        otros_cargos: 0,
                        percepcion: this.calculoPercepcionCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          res[0] == undefined ? res : res[0].con_percepcion,
                          results.data[a][24]
                        ),
                        retencion: this.calculoRetencionCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          res[0] == undefined ? res : res[0].con_retencion,
                          results.data[a][25]
                        ),
                        iva: Number(
                          this.calculoIvaCSV(
                            id_doc_fiscal.cod_doc_fiscal,
                            results.data[a][27]
                          )
                        ),
                        sub_total:
                          Number(results.data[a][27]) +
                          Number(results.data[a][28]) +
                          Number(results.data[a][29]),
                        cod_cliente: "",
                        Customer: "",
                        NIT: "",
                        LineofBusiness: "",
                        Country: "",
                        Address: "",
                        ciudad: "",
                        estado: "",
                        Phonenumber: "",
                        correo1: results.data[a][23],
                        correo2: "",
                        correo3: "",
                        consignado_a: "",
                        consignado_a_direccion: "",
                        descuento: 0.0,
                        seguro: 0.0,
                        transporte: 0.0,
                        total_pagar:
                          Number(results.data[a][27]) +
                          Number(
                            this.calculoIvaCSV(
                              id_doc_fiscal.cod_doc_fiscal,
                              Number(results.data[a][27])
                            )
                          ) -
                          Number(
                            this.calculoRetencionCSV(
                              id_doc_fiscal.cod_doc_fiscal,
                              res[0] == undefined ? res : res[0].con_retencion,
                              Number(results.data[a][27])
                            )
                          ) +
                          Number(
                            this.calculoPercepcionCSV(
                              id_doc_fiscal.cod_doc_fiscal,
                              res[0] == undefined ? res : res[0].con_percepcion,
                              Number(results.data[a][27])
                            )
                          ) +
                          Number(results.data[a][28]) +
                          Number(results.data[a][29]),
                        tipo_pago:
                          results.data[a][1] == "01" ? "CONTADO" : "CREDITO",
                        incoterms: "",
                        comentario: "",
                        referencia: "",
                        sample_charge: 0.0,
                        otros: 0.0,
                        efficiency_surcharge: 0.0,
                        light_weight_charge_money: 0.0,
                        bags_per_piece: "",
                        pais_origen: "",
                        total_pounds: 0.0,
                        gross_weight: "",
                        raw_material: 0.0,
                        added_value: 0.0,
                        customs_total: 0.0,
                        gravadas: results.data[a][27],
                        total_operacion:
                          Number(results.data[a][27]) +
                          Number(
                            this.calculoIvaCSV(
                              id_doc_fiscal.cod_doc_fiscal,
                              results.data[a][27]
                            )
                          ) -
                          Number(
                            this.calculoRetencionCSV(
                              id_doc_fiscal.cod_doc_fiscal,
                              res[0] == undefined ? res : res[0].con_retencion,
                              Number(results.data[a][27])
                            )
                          ) +
                          Number(
                            this.calculoPercepcionCSV(
                              id_doc_fiscal.cod_doc_fiscal,
                              res[0] == undefined ? res : res[0].con_percepcion,
                              Number(results.data[a][27])
                            )
                          ) +
                          Number(results.data[a][28]) +
                          Number(results.data[a][29]),
                        estatus: "GUARDADO",
                        es_anulado: false,
                        metodo_pago: results.data[a][2],
                      },
                      detalles: [
                        {
                          cod_servicio: "01",
                          descuento: 0,
                          estilo: "",
                          cantidad: results.data[a][17],
                          unidad_medida: "",
                          descripcion: results.data[a][18],
                          comp_pedido: results.data[a][19],
                          descripcion2: "",
                          precio:
                            results.data[a][26] != null
                              ? results.data[a][26]
                              : 0,
                          total: results.data[a][17] * results.data[a][26],
                        },
                      ],
                    });
                    cont_detalle++;
                  } else {
                    this.result_data_facturas[flag_index].encabezado.sub_total =
                      Number(
                        this.result_data_facturas[flag_index].encabezado
                          .sub_total
                      ) +
                      Number(results.data[a][27]) +
                      Number(results.data[a][28]) +
                      Number(results.data[a][29]);
                    this.result_data_facturas[flag_index].encabezado.gravadas =
                      Number(
                        this.result_data_facturas[flag_index].encabezado
                          .gravadas
                      ) + Number(results.data[a][27]);
                    this.result_data_facturas[flag_index].encabezado.iva =
                      Number(
                        this.calculoIvaCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          this.result_data_facturas[flag_index].encabezado
                            .gravadas
                        )
                      );
                    this.result_data_facturas[
                      flag_index
                    ].encabezado.total_operacion =
                      Number(
                        this.result_data_facturas[flag_index].encabezado
                          .total_operacion
                      ) +
                      Number(results.data[a][27]) +
                      Number(
                        this.calculoIvaCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          results.data[a][27]
                        )
                      ) -
                      Number(
                        this.calculoRetencionCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          res[0] == undefined ? res : res[0].con_retencion,
                          Number(results.data[a][27])
                        )
                      ) +
                      Number(
                        this.calculoPercepcionCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          res[0] == undefined ? res : res[0].con_percepcion,
                          Number(results.data[a][27])
                        )
                      ) +
                      Number(results.data[a][28]) +
                      Number(results.data[a][29]);
                    this.result_data_facturas[
                      flag_index
                    ].encabezado.total_pagar =
                      Number(
                        this.result_data_facturas[flag_index].encabezado
                          .total_pagar
                      ) +
                      Number(results.data[a][27]) +
                      Number(
                        this.calculoIvaCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          Number(results.data[a][27])
                        )
                      ) -
                      Number(
                        this.calculoRetencionCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          res[0] == undefined ? res : res[0].con_retencion,
                          Number(results.data[a][27])
                        )
                      ) +
                      Number(
                        this.calculoPercepcionCSV(
                          id_doc_fiscal.cod_doc_fiscal,
                          res[0] == undefined ? res : res[0].con_percepcion,
                          Number(results.data[a][27])
                        )
                      ) +
                      Number(results.data[a][28]) +
                      Number(results.data[a][29]);

                    this.result_data_facturas[flag_index].detalles.push({
                      cod_servicio: "01",
                      descuento: 0,
                      estilo: "",
                      cantidad: results.data[a][17],
                      unidad_medida: "",
                      descripcion: results.data[a][18],
                      comp_pedido: results.data[a][19],
                      descripcion2: "",
                      precio:
                        results.data[a][26] != null ? results.data[a][26] : 0,
                      total: results.data[a][17] * results.data[a][26],
                    });
                  }
                });
              }
            },
          });
        }
        //console.log(this.result_data_facturas);
        this.loading_guardar = false;
        this.items_csv = this.result_data_facturas;
      }
    },
    async guardarCSV() {
      /*var bloc = await this.verificarBloc();
      if (!bloc.bloc) {
        this.alerta("info", "Ya no posee disponibilidad de facturas");
        return;
      }

      if (bloc.bloc_restante == 0) {
        this.alerta("info", "Ya no posee disponibilidad de facturas");
        return;
      }*/

      for (var i = 0; i < this.result_data_facturas.length; i++) {
        this.loading_guardar = true;
        await axios
          .post("api/Facturas/CrearCSV", {
            encabezado: this.result_data_facturas[i].encabezado,
            detalle: this.result_data_facturas[i].detalles,
          })
          .then(async () => {
            this.incrementarCorrelativoTipoDocCSV(
              this.result_data_facturas[i].encabezado.id_tipo_doc_fiscal
            );
            //await actualizarBloc("nuevo");
          });
      }
      this.loading_guardar = false;
      this.flag_csv = "no";
      this.data_file_input = [];
      this.items_csv = [];
      this.file = [];
      this.listarFacturas();
    },
    async verificarBloc() {
      var res = await axios
        .get(
          "api/DetallesEmpresas/VerificarBloc/" +
            this.$store.state.emp.id_empresa
        )
        .then((response) => {
          return response.data;
        });
      return res[0];
    },
    async actualizarBloc(tipo_fac) {
      await axios.put("api/DetallesEmpresas/ActualizarBloc", {
        id_empresa: this.$store.state.emp.id_empresa,
        bloc_restante: tipo_fac, //nuevo o eliminado
        bloc_sumados: tipo_fac, //nuevo o eliminado
      });
    },
    async enviarDTE(item) {
      this.loading_facturas = true;
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
        })
        .then((response) => {
          this.loading_facturas = false;
          this.snackbar_text = response.data;
          this.snackbar = true;
          this.listarFacturas();
        })
        .catch(() => {
          this.loading_facturas = false;
          this.snackbar_text = this.$t("snackbar-t1");
          this.snackbar = true;
        });
    },
    confirmarEnviarTodoDte() {
      this.dialog_enviar_todo_dte = true;
    },
    async enviarTodoDTE() {
      //console.log(this.items);
      this.snackbar_text = "";
      this.loading_enviar_todo = true;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].sello_recepcion == "") {
          await axios
            .post("api/ServicioRecepciones/FirmarDocumento2", {
              cod_emp: this.$store.state.emp.id_empresa,
              tipoDte: this.items[i].cod_doc_fiscal,
              idFactura: this.items[i].id_factura,
              ambiente: await this.obtenerAmbiente(),
            })
            .then((response) => {
              if (response.data.estado == "RECHAZADO") {
                this.snackbar_text =
                  this.snackbar_text +
                  " " +
                  this.items[i].numero_control +
                  ": " +
                  response.data.estado +
                  " " +
                  response.data.descripcionMsg +
                  "\n\n";
              }
              this.listarFacturas();
            });
        }
      }
      this.dialog_enviar_todo_dte = false;
      this.loading_enviar_todo = false;
      this.alerta("info", this.snackbar_text);
    },
    async vistaPreviaPdf(item) {
      //console.log(item);
      this.loading_facturas = true;

      axios
        .post("api/ServicioRecepciones/VistaPreviaDTE2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
          es_previo: true,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_facturas = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = this.$t("snackbar-t2");
          this.snackbar = true;
          this.loading_facturas = false;
        });
    },
    async vistaPreviaPdfSello(item) {
      this.loading_facturas = true;
      axios
        .post("api/ServicioRecepciones/DescargarFacturaWeb", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
          es_previo: false,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_facturas = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = this.$t("snackbar-t2");
          this.snackbar = true;
          this.loading_facturas = false;
        });
    },
    reenviarCorreo(item) {
      //console.log(item);
      axios
        .post("api/ServicioRecepciones/EnviarCorreos", {
          id_emp: item.id_empresa,
          cod_emp: this.$store.state.emp.cod_empresa,
          nom_base: "sqlserver",
          codFactura: item.codigo_generacion,
          tipoDte: item.cod_doc_fiscal,
          origen: "SQLSERVER",
        })
        .then(() => {
          this.snackbar_text = this.$t("snackbar-t3");
          this.snackbar = true;
        })
        .catch(() => {
          this.snackbar_text = this.$t("snackbar-t1");
          this.snackbar = true;
        });
    },
    listarFacturas() {
      this.loading_facturas = true;
      axios
        .get("api/Facturas/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          //console.log(response.data);
          this.items = response.data;
          this.loading_facturas = false;
        })
        .catch(() => {
          this.loading_facturas = false;
        });
    },
    listarUsuarioSucursal() {
      axios
        .get(
          "api/Usuarios/ListarUsuariosSucursales/" +
            this.$store.state.emp.id_empresa +
            "/" +
            this.$store.state.usuario.idUsuario
        )
        .then((response) => {
          //console.log(response.data);
          this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
          this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
        });
    },
    listarSucursales() {
      axios
        .get("api/Sucursales/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
          this.sucursal = response.data[0].id_sucursal;
          this.listarPuntosVenta("auto");
        });
    },
    listarPuntosVenta(estado) {
      axios
        .get(
          "api/PuntoVentas/ListarXsucursal/" +
            this.$store.state.emp.id_empresa +
            "/" +
            this.sucursal
        )
        .then((response) => {
          //console.log(response.data);
          this.items_punto_venta = response.data;
          this.punto_venta = response.data[0].id_punto_venta;
          this.listarTipoDocs();

          if (estado != "auto" && this.tipo_doc_fiscal == "") {
            this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
            this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
          } else if (estado != "auto" && this.tipo_doc_fiscal != undefined) {
            this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
            this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
            this.listarDocSeleccionado();
          }
        });
    },
    listarTipoDocs() {
      if (this.sucursal) {
        axios
          .get(
            "api/ConfiFacturas/Listar/" +
              this.sucursal +
              "/" +
              this.punto_venta +
              "/" +
              this.$store.state.emp.id_empresa
          )
          .then((response) => {
            this.items_tipo_doc_fiscales = response.data;

            this.llamarCalculo();
          });
      }
    },
    llamarCalculo() {
      for (var i = 0; i < this.items_productos.length; i++) {
        this.limpiarCalculosCabecera();

        for (var i = 0; i < this.items_productos.length; i++) {
          //CALCULOS DE DESCUENTO
          this.sumarDescuentos();

          //CALCULOS DE EXENTO Y NO SUJETO
          if (this.cliente_exento) {
            this.calculoExento(this.items_productos[i].total);
            this.limpiarCamposProductos();
            continue;
          }

          if (this.items_productos[i].exento) {
            this.calculoExento(this.items_productos[i].total);
            this.limpiarCamposProductos();
            continue;
          }
          if (this.items_productos[i].no_sujeto) {
            this.calculoNoSujeto();
            this.limpiarCamposProductos();
            continue;
          }

          if (this.cliente_percepcion) {
            if (this.total >= 100) {
              this.percepcion =
                Number(this.percepcion) +
                (Number(this.items_productos[i].total) * Number(0.01)).toFixed(
                  2
                );
            }
          }

          this.sumarSubTotales(this.items_productos[i].total);
          this.calculoGravadas(this.sub_total, this.descuento);

          if (
            this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
            this.tipo_doc_fiscal.cod_doc_fiscal == "NCR" ||
            this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
            this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
          ) {
            this.calculoIva(this.gravadas);
          }
        }
      }
    },
    listarClientes() {
      axios
        .get("api/Clientes/ListarTodos/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_clientes = response.data;
        });
    },
    nuevaFactura() {
      this.fecha_hora = settings.metodos.formatoFechaHora(new Date());
      this.obtenerGuid();
      this.flag_new_edit = 1;
      this.dialog = true;
    },
    async obtenerGuidCSV() {
      return await (
        await axios.get("api/Facturas/GenerarGuid")
      ).data;
    },
    obtenerGuid() {
      axios.get("api/Facturas/GenerarGuid").then((response) => {
        this.codigo_generacion = response.data;
      });
    },
    asignarProducto() {
      axios
        .get(
          "api/Servicios/ObtenerServicioPorCodigo/" +
            this.producto +
            "/" +
            this.$store.state.emp.id_empresa
        )
        .then((response) => {
          //console.log(response.data);
          if (
            this.tipo_doc_fiscal.cod_doc_fiscal == "FAC" ||
            this.tipo_doc_fiscal.cod_doc_fiscal == "FEX"
          ) {
            if (response.data.exento || response.data.no_sujeto) {
              this.precio = (
                Number(response.data.precio) / Number(1.13)
              ).toFixed(2);
            } else {
              this.precio = response.data.precio;
            }
          } else {
            this.precio = (Number(response.data.precio) / Number(1.13)).toFixed(
              2
            );
          }
          this.flag_servicio = response.data == "" ? true : false;
          this.descripcion = response.data.nom_servicio;
          this.total = (Number(this.precio) * Number(this.cantidad)).toFixed(2);
          this.exento_prod = response.data.exento;
          this.no_sujeto_prod = response.data.no_sujeto;
        });
    },
    modificarPrecio() {
      this.precio = Number(this.precio).toFixed(2);
      this.total = Number(this.precio).toFixed(2);
    },
    calculoDescuento() {
      this.monto_descuento = 0;
      this.monto_descuento =
        Number(this.cantidad) *
        Number(this.precio) *
        (Number(this.descuento_prod) / 100);
      this.total = (Number(this.total) - Number(this.monto_descuento)).toFixed(
        2
      );
    },
    setCliente() {
      this.id_cliente = this.cliente.id_cliente;
      this.nombre = this.cliente.nombre;
      this.registro = this.cliente.registro;
      this.identifiador = this.cliente.identificador_nombre;
      this.telefono = this.cliente.telefono;
      this.tipo = this.cliente.tipo_persona;
      this.cliente_exento = this.cliente.exento;
      this.cliente_retencion = this.cliente.con_retencion;
      this.cliente_percepcion = this.cliente.con_percepcion;
      this.cliente_tamaño = this.cliente.tamaño;
      this.cliente_extranjero = this.cliente.extranjero;
      this.num_documento = this.cliente.documento;

      this.llamarCalculo();

      this.dialog_clientes = false;
    },
    async obtenerClienteDocCsv(
      doc_cliente,
      nombre,
      direccion,
      correo,
      extranjero,
      tipo_exportacion,
      pais,
      tipo_doc_fiscal,
      registro
    ) {
      return await axios
        .get(
          "api/Clientes/ListarXDoc/" +
            this.$store.state.emp.id_empresa +
            "/" +
            doc_cliente
        )
        .then(async (res) => {
          if (res.data.length > 0) {
            return res.data;
          } else {
            var _id = await axios
              .post("api/Clientes/Crear", {
                fecha_ingreso: settings.metodos.formatoFecha(new Date()),
                codigo: doc_cliente,
                documento: doc_cliente,
                nombre: nombre,
                direccion: direccion,
                correo_1: correo,
                extranjero: extranjero == 1 ? true : false,
                id_tipo_exportacion:
                  tipo_exportacion != ""
                    ? await this.obtenerTipoExportacionCsv(tipo_exportacion)
                    : null,
                id_pais: await this.obtenerPaisCsv(pais),
                id_tipo_doc_fiscal: await this.obtenerTipoDocCsv(
                  tipo_doc_fiscal
                ).then((x) => {
                  console.log(x);

                  return x.id_tipo_doc_fiscal;
                }),
                id_departamento: 2, //San Salvador
                id_municipio: 89, //San Salvador
                id_identificador: 3, //Otros
                id_empresa: this.$store.state.emp.id_empresa,
                cliente_activo: true,
                id_actividad_economica: 771, // Otros
                telefono: "00000000",
                registro: registro,
              })
              .then((response) => {
                //console.log(response.data);
                return response.data;
              });
            return _id;
          }
        });
    },
    async obtenerTipoExportacionCsv(cod) {
      return (await axios.get("api/TipoExportaciones/ListarXCod/" + cod))
        .data[0].id_tipo_exportacion;
    },
    async obtenerPaisCsv(cod) {
      return (await axios.get("api/Paises/ListarXCod/" + cod)).data[0].id_pais;
    },
    listarServicios() {
      axios
        .get("api/Servicios/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          //console.log(response.data);
          this.items_servicios = response.data;
        });
    },
    setServicio(event, { item }) {
      if (
        this.tipo_doc_fiscal.cod_doc_fiscal == "FAC" ||
        this.tipo_doc_fiscal.cod_doc_fiscal == "FEX"
      ) {
        if (item.exento || item.no_sujeto) {
          this.precio = (Number(item.precio) / Number(1.13)).toFixed(2);
        } else {
          this.precio = item.precio;
        }
      } else {
        this.precio = (Number(item.precio) / Number(1.13)).toFixed(2);
      }

      this.producto = item.cod_servicio;
      this.descripcion = item.nom_servicio;
      this.comprovante_pedido = item.comp_pedido;
      this.total = (Number(this.precio) * Number(this.cantidad)).toFixed(2);
      this.exento_prod = item.exento;
      this.no_sujeto_prod = item.no_sujeto;

      this.dialog_servicios = false;
    },
    agregarProducto() {
      if (!this.cliente || !this.tipo_doc_fiscal) {
        this.snackbar_text = this.$t("snackbar-t4");
        this.snackbar = true;
        return;
      }
      if (this.tipo_doc_fiscal.cod_doc_fiscal == "FEX") {
        if (this.cliente_extranjero == false) {
          this.snackbar_text = this.$t("snackbar-t5");
          this.snackbar = true;
          return;
        }
      }

      if (!this.producto) {
        this.snackbar_text = this.$t("snackbar-t6");
        this.snackbar = true;
        return;
      }

      if (this.id_detalle_factura == -1) {
        var index = this.items_productos.findIndex(
          (item) => item.id == this.id
        );
        if (index != -1) {
          this.editarDetalleServicio(index);
          return;
        }
      } else if (this.id_detalle_factura > 0) {
        var index = this.items_productos.findIndex(
          (item) => item.id_detalle_factura == this.id_detalle_factura
        );
        this.editarDetalleServicio(index);
        return;
      }

      this.cont_prod++;

      this.sumarDescuentos();

      this.items_productos.push({
        id: this.cont_prod,
        id_detalle_factura: -1,
        cantidad: this.cantidad,
        cod_servicio: this.producto,
        descripcion: this.descripcion,
        precio: this.precio,
        descuento: this.descuento_prod,
        total: this.total,
        exento: this.exento_prod,
        no_sujeto: this.no_sujeto_prod,
        comp_pedido: this.comprovante_pedido,
      });

      if (this.cliente_exento) {
        this.calculoExento(this.total);
        this.limpiarCamposProductos();
        return;
      }

      if (this.exento_prod) {
        this.calculoExento(this.total);
        this.limpiarCamposProductos();
        return;
      }
      if (this.no_sujeto_prod) {
        this.calculoNoSujeto();
        this.limpiarCamposProductos();
        return;
      }

      /*if (this.tipo_doc_fiscal.cod_doc_fiscal == "FAC") {
        if (this.cliente_retencion) {
          if (this.total >= 100) {
            var sin_iva = (this.total / 1.13).toFixed(2);
            this.retencion = (Number(this.retencion) + sin_iva * 0.01).toFixed(
              2
            );
          }
        }
      } else {
        if (this.cliente_retencion) {
          if (this.total >= 100) {
            this.retencion = (
              Number(this.retencion) +
              Number(this.total) * Number(0.01)
            ).toFixed(2);
          }
        }
      }*/

      if (this.cliente_percepcion) {
        if (this.total >= 100) {
          this.percepcion = (Number(this.total) * Number(0.01)).toFixed(2);
        }
      }

      this.sumarSubTotales(this.total);
      this.calculoGravadas(this.sub_total, this.descuento);

      if (
        this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
        this.tipo_doc_fiscal.cod_doc_fiscal == "NCR" ||
        this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
        this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
      ) {
        this.calculoIva(this.gravadas);
      }

      this.limpiarCamposProductos();
    },
    editarDetalleServicio(index) {
      this.items_productos[index].cantidad = this.cantidad;
      this.items_productos[index].cod_servicio = this.producto;
      this.items_productos[index].descripcion = this.descripcion;
      this.items_productos[index].precio = this.precio;
      this.items_productos[index].descuento = this.descuento_prod;
      this.items_productos[index].total = Number(this.total);
      this.items_productos[index].exento = this.exento_prod;
      this.items_productos[index].no_sujeto = this.no_sujeto_prod;
      this.items_productos[index].comp_pedido = this.comprovante_pedido;

      this.id_detalle_factura = 0;
      this.limpiarCalculosCabecera();

      for (var i = 0; i < this.items_productos.length; i++) {
        //CALCULOS DE DESCUENTO
        this.sumarDescuentos();

        //CALCULOS DE EXENTO Y NO SUJETO
        if (this.cliente_exento) {
          this.calculoExento(this.items_productos[i].total);
          this.limpiarCamposProductos();
          continue;
        }

        if (this.items_productos[i].exento) {
          this.calculoExento(this.items_productos[i].total);
          this.limpiarCamposProductos();
          continue;
        }
        if (this.items_productos[i].no_sujeto) {
          this.calculoNoSujeto();
          this.limpiarCamposProductos();
          continue;
        }

        if (this.tipo_doc_fiscal.cod_doc_fiscal == "FAC") {
          if (this.cliente_retencion) {
            if (this.items_productos[i].total >= 100) {
              var sin_iva = (this.items_productos[i].total / 1.13).toFixed(2);
              this.retencion = (
                Number(this.retencion) +
                sin_iva * 0.01
              ).toFixed(2);
            }
          }
        } else {
          if (this.cliente_retencion) {
            if (this.items_productos[i].total >= 100) {
              this.retencion = (
                Number(this.retencion) +
                Number(this.items_productos[i].total) * Number(0.01)
              ).toFixed(2);
            }
          }
        }

        if (this.cliente_percepcion) {
          if (this.items_productos[i].total >= 100) {
            this.percepcion =
              Number(this.percepcion) +
              (Number(this.items_productos[i].total) * Number(0.01)).toFixed(2);
          }
        }

        this.sumarSubTotales(this.items_productos[i].total);
        this.calculoGravadas(this.sub_total, this.descuento);

        if (
          this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NCR" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
        ) {
          this.calculoIva(this.gravadas);
        }

        this.limpiarCamposProductos();
      }
    },
    sumarSubTotales(v_total) {
      this.sub_total = parseFloat(
        Number(this.sub_total) + Number(v_total)
      ).toFixed(2);
    },
    sumarDescuentos() {
      if (this.descuento_prod > 0) {
        this.flag_descuento = true;
      }
      this.descuento = parseFloat(
        Number(this.descuento) + Number(this.monto_descuento)
      ).toFixed(2);
    },
    calculoGravadas(v_sub_total, v_descuento) {
      this.gravadas = parseFloat(
        Number(v_sub_total) - Number(v_descuento)
      ).toFixed(2);
    },
    calculoIva(v_gravadas) {
      this.iva = parseFloat(Number(v_gravadas) * Number(0.13)).toFixed(2);
    },
    calculoExento(v_total) {
      this.exentas = (Number(this.exentas) + Number(v_total)).toFixed(2);
    },
    calculoNoSujeto() {
      this.no_sujetas = (Number(this.no_sujetas) + Number(this.total)).toFixed(
        2
      );
    },
    editarFactura(item) {
      //console.log(item);
      this.id_factura = item.id_factura;
      this.id_tipo_doc_fiscal = item.id_tipo_doc_fiscal;
      this.tipo_doc_fiscal = item;
      this.id_cliente = item.id_cliente;
      this.id_empresa = item.id_empresa;
      this.sucursal = item.id_sucursal;
      this.numero_control = item.numero_control;
      this.codigo_generacion = item.codigo_generacion;
      this.fecha_hora = item.fecha;
      this.sello_recepcion = item.sello_recepcion;
      this.fecha_recepcion = item.fecha_recepcion;
      this.tipo_pago = item.tipo_pago;
      this.otros_cargos = item.otros_cargos;
      this.anticipo = item.anticipo;
      this.sub_total = item.sub_total;
      this.descuento = item.descuento;
      this.gravadas = item.gravadas;
      this.iva = item.iva;
      this.exentas = item.exentas;
      this.no_sujetas = item.no_sujetas;
      this.retencion = item.retencion;
      this.percepcion = item.percepcion;
      this.total_operacion = item.total_operacion;
      this.total_pagar = item.total_pagar;
      this.codigo_bien = item.codigo_bien;
      this.extingido_cautelado = item.extingido_cautelado;
      this.consignado_a = item.consignado_a;
      this.resolucion_invalidacion = item.resolucion_invalidacion;

      this.cliente = item.cliente_codigo;
      this.nombre = item.cliente_nombre;
      this.registro = item.cliente_registro;
      this.identifiador = item.cliente_identificador;
      this.telefono = item.cliente_telefono;
      this.tipo = item.cliente_tipo;
      this.cliente_exento = item.cliente_exento;
      this.cliente_retencion = item.cliente_retencion;
      this.cliente_percepcion = item.cliente_percepcion;
      this.cliente_extranjero = item.cliente_extranjero;

      this.listarDetallesfactura();

      this.flag_new_edit = 2;
      this.dialog = true;
    },
    eliminarDetalleFactura(item) {
      this.item_servicio_eliminar = item;
      this.dialog_eliminar_servicio = true;
    },
    confirmarEliminarDetalleFactura() {
      if (this.item_servicio_eliminar.id_detalle_factura > 0) {
        axios
          .delete(
            "api/DetallesFacturas/Eliminar/" +
              this.item_servicio_eliminar.id_detalle_factura
          )
          .then(() => {
            var index = this.items_productos.findIndex(
              (item) =>
                item.id_detalle_factura ==
                this.item_servicio_eliminar.id_detalle_factura
            );
            if (index != -1) {
              this.items_productos.splice(index, 1);
            }

            this.limpiarCalculosCabecera();

            for (var i = 0; i < this.items_productos.length; i++) {
              //CALCULOS DE DESCUENTO
              this.sumarDescuentos();

              //CALCULOS DE EXENTO Y NO SUJETO
              if (this.cliente_exento) {
                this.calculoExento(this.items_productos[i].total);
                this.limpiarCamposProductos();
                continue;
              }

              if (this.items_productos[i].exento) {
                this.calculoExento(this.items_productos[i].total);
                this.limpiarCamposProductos();
                continue;
              }
              if (this.items_productos[i].no_sujeto) {
                this.calculoNoSujeto();
                this.limpiarCamposProductos();
                continue;
              }

              if (this.tipo_doc_fiscal.cod_doc_fiscal == "FAC") {
                if (this.cliente_retencion) {
                  if (this.items_productos[i].total >= 100) {
                    var sin_iva = (
                      this.items_productos[i].total / 1.13
                    ).toFixed(2);
                    this.retencion = (
                      Number(this.retencion) +
                      sin_iva * 0.01
                    ).toFixed(2);
                  }
                }
              } else {
                if (this.cliente_retencion) {
                  if (this.items_productos[i].total >= 100) {
                    this.retencion = (
                      Number(this.retencion) +
                      Number(this.items_productos[i].total) * Number(0.01)
                    ).toFixed(2);
                  }
                }
              }

              if (this.cliente_percepcion) {
                if (this.items_productos[i].total >= 100) {
                  this.percepcion = (
                    Number(this.percepcion) +
                    Number(this.items_productos[i].total) * Number(0.01)
                  ).toFixed(2);
                }
              }

              this.sumarSubTotales(this.items_productos[i].total);
              this.calculoGravadas(this.sub_total, this.descuento);

              if (
                this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
                this.tipo_doc_fiscal.cod_doc_fiscal == "NCR" ||
                this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
                this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
              ) {
                this.calculoIva(this.gravadas);
              }
            }
            this.dialog_eliminar_servicio = false;
            this.snackbar_text = this.$t("snackbar-t7");
            this.snackbar = true;
          })
          .catch(() => {
            this.snackbar_text = this.$t("snackbar-t8");
            this.snackbar = true;
          });
      } else {
        var index = this.items_productos.findIndex(
          (item) =>
            item.id_detalle_factura ==
            this.item_servicio_eliminar.id_detalle_factura
        );

        if (index != -1) {
          this.items_productos.splice(index, 1);
        }

        this.limpiarCalculosCabecera();

        for (var i = 0; i < this.items_productos.length; i++) {
          //CALCULOS DE DESCUENTO
          this.sumarDescuentos();

          //CALCULOS DE EXENTO Y NO SUJETO
          if (this.cliente_exento) {
            this.calculoExento(this.items_productos[i].total);
            this.limpiarCamposProductos();
            continue;
          }

          if (this.items_productos[i].exento) {
            this.calculoExento(this.items_productos[i].total);
            this.limpiarCamposProductos();
            continue;
          }
          if (this.items_productos[i].no_sujeto) {
            this.calculoNoSujeto();
            this.limpiarCamposProductos();
            continue;
          }

          if (this.tipo_doc_fiscal.cod_doc_fiscal == "FAC") {
            if (this.cliente_retencion) {
              if (this.items_productos[i].total >= 100) {
                var sin_iva = (this.items_productos[i].total / 1.13).toFixed(2);
                this.retencion = (
                  Number(this.retencion) +
                  sin_iva * 0.01
                ).toFixed(2);
              }
            }
          } else {
            if (this.cliente_retencion) {
              if (this.items_productos[i].total >= 100) {
                this.retencion = (
                  Number(this.retencion) +
                  Number(this.items_productos[i].total) * Number(0.01)
                ).toFixed(2);
              }
            }
          }

          if (this.cliente_percepcion) {
            if (this.total >= 100) {
              this.percepcion = (
                Number(this.percepcion) +
                Number(this.items_productos[i].total) * Number(0.01)
              ).toFixed(2);
            }
          }

          this.sumarSubTotales(this.items_productos[i].total);
          this.calculoGravadas(this.sub_total, this.descuento);

          if (
            this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
            this.tipo_doc_fiscal.cod_doc_fiscal == "NCR" ||
            this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
            this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
          ) {
            this.calculoIva(this.gravadas);
          }
        }
        this.dialog_eliminar_servicio = false;
        this.snackbar_text = this.$t("snackbar-t7");
        this.snackbar = true;
      }
    },
    editarProducto(item) {
      this.id = item.id;
      this.id_detalle_factura = item.id_detalle_factura;
      this.cantidad = item.cantidad;
      this.producto = item.cod_servicio;
      this.descripcion = item.descripcion;
      this.comprovante_pedido = item.comp_pedido;
      this.precio = item.precio;
      this.descuento = item.descuento;
      this.total = item.total;
      this.exento_prod = item.exento;
      this.no_sujeto_prod = item.no_sujeto;
    },
    async crearfactura() {
      var obj_blocs = await (
        await axios.get(
          "api/DetallesEmpresas/VerificarBlob/" +
            this.$store.state.emp.id_empresa
        )
      ).data;
      //console.log(obj_blocs[0]);
      if (obj_blocs[0].bloc) {
        if (obj_blocs[0].bloc_restante == 0) {
          this.snackbar_text = this.$t("snackbar-t9");
          this.snackbar = true;
          return;
        }
      }

      var items_detalles_factura_ncr = [];
      var items_facturas_ndb = [];

      if (this.total_pagar == 0) {
        this.snackbar_text = this.$t("snackbar-t10");
        this.snackbar = true;
        return;
      }

      for (var i = 0; i < this.items_productos.length; i++) {
        if (this.tipo_doc_fiscal.cod_doc_fiscal == "NCR") {
          items_detalles_factura_ncr.push({
            cantidad: this.items_productos[i].cantidad,
            cod_servicio: this.items_productos[i].cod_servicio,
            descripcion: this.items_productos[i].descripcion,
            precio: this.items_productos[i].precio,
            descuento: this.items_productos[i].descuento,
            total: this.items_productos[i].total,
            exento: this.items_productos[i].exento,
            no_sujeto: this.items_productos[i].no_sujeto,
            id_detalle_factura_ncr: this.items_productos[i].id_detalle_factura,
            comp_pedido: this.items_productos[i].comp_pedido,
          });

          var index = this.items_tipo_doc_ncr_ndb.findIndex(
            (item) => item.id_factura == this.items_productos[i].id_factura
          );
          if (index == -1) {
            this.items_tipo_doc_ncr_ndb.push({
              id_empresa: this.$store.state.emp.id_empresa,
              id_factura_relacionado: this.items_productos[i].id_factura,
            });
          }
        } else {
          items_detalles_factura_ncr.push(this.items_productos[i]);
        }
      }

      for (var i = 0; i < this.items_tipo_doc_ncr_ndb.length; i++) {
        items_facturas_ndb.push({
          id_empresa: this.$store.state.emp.id_empresa,
          id_factura_relacionado:
            this.items_tipo_doc_ncr_ndb[i].id_factura_relacionado,
        });
      }

      if (items_detalles_factura_ncr.length == 0) {
        this.snackbar_text = this.$t("snackbar-t11");
        this.snackbar = true;
        return;
      }

      this.loading_guardar = true;
      axios
        .post("api/Facturas/Crear", {
          id_tipo_doc_fiscal: this.tipo_doc_fiscal.id_tipo_doc_fiscal,
          id_cliente: this.id_cliente,
          id_empresa: this.$store.state.emp.id_empresa,
          id_sucursal: this.sucursal,
          id_punto_venta: this.punto_venta,
          numero_control: this.numero_control,
          codigo_generacion: this.codigo_generacion,
          fecha: this.fecha_hora,
          sello_recepcion: this.sello_recepcion,
          fecha_recepcion: this.fecha_recepcion,
          tipo_pago: this.tipo_pago,
          otros_cargos: this.otros_cargos,
          anticipo: this.anticipo,
          sub_total: this.sub_total,
          descuento: this.descuento,
          gravadas: this.gravadas,
          iva: this.iva,
          exentas: this.exentas,
          no_sujetas: this.no_sujetas,
          retencion: this.retencion,
          percepcion: this.percepcion,
          total_operacion: this.total_operacion,
          total_pagar: this.total_pagar,
          es_anulado: false,
          estatus: "GUARDADO",
          ciudad: "",
          estado: "",
          Phonenumber: "",
          correo1: "",
          correo2: "",
          correo3: "",
          consignado_a: "",
          consignado_a_direccion: "",
          descuento: 0.0,
          seguro: 0.0,
          transporte: 0.0,
          incoterms: "",
          comentario: "",
          referencia: "",
          sample_charge: 0.0,
          otros: 0.0,
          efficiency_surcharge: 0.0,
          light_weight_charge_money: 0.0,
          bags_per_piece: 0.0,
          pais_origen: "",
          total_pounds: 0.0,
          gross_weight: 0.0,
          raw_material: 0.0,
          added_value: 0.0,
          customs_total: 0.0,
          codigo_bien: this.codigo_bien,
          extingido_cautelado: this.extingido_cautelado,
          metodo_pago: this.metodo_pago,
          detalleFactura: items_detalles_factura_ncr,
          detalleNDB_NCR: items_facturas_ndb,
          saldo: this.total_pagar,
        })
        .then(async () => {
          this.snackbar_text = this.$t("snackbar-t12");
          this.snackbar = true;
          this.loading_guardar = false;
          await this.actualizarBlocs("nuevo");
          this.cerrarDialog();
          this.listarFacturas();
        })
        .catch(() => {
          this.snackbar_text = this.$t("snackbar-t13");
          this.snackbar = true;
          this.loading_guardar = false;
        });
    },
    actualizarfactura() {
      axios
        .put("api/Facturas/Actualizar", {
          id_factura: this.id_factura,
          id_tipo_doc_fiscal: this.tipo_doc_fiscal.id_tipo_doc_fiscal,
          id_cliente: this.id_cliente,
          id_empresa: this.$store.state.emp.id_empresa,
          id_sucursal: this.sucursal,
          id_punto_venta: this.punto_venta,
          numero_control: this.numero_control,
          codigo_generacion: this.codigo_generacion,
          fecha: this.fecha_hora,
          sello_recepcion: this.sello_recepcion,
          fecha_recepcion: this.fecha_recepcion,
          tipo_pago: this.tipo_pago,
          otros_cargos: this.otros_cargos,
          anticipo: this.anticipo,
          sub_total: this.sub_total,
          descuento: this.descuento,
          gravadas: this.gravadas,
          iva: this.iva,
          exentas: this.exentas,
          no_sujetas: this.no_sujetas,
          retencion: this.retencion,
          percepcion: this.percepcion,
          total_operacion: this.total_operacion,
          total_pagar: this.total_pagar,
          estatus: "GUARDADO",
          ciudad: "",
          estado: "",
          Phonenumber: "",
          correo1: "",
          correo2: "",
          correo3: "",
          consignado_a: "",
          consignado_a_direccion: "",
          descuento: 0.0,
          seguro: 0.0,
          transporte: 0.0,
          incoterms: "",
          comentario: "",
          referencia: "",
          sample_charge: 0.0,
          otros: 0.0,
          efficiency_surcharge: 0.0,
          light_weight_charge_money: 0.0,
          bags_per_piece: 0.0,
          pais_origen: "",
          total_pounds: 0.0,
          gross_weight: 0.0,
          raw_material: 0.0,
          added_value: 0.0,
          customs_total: 0.0,
          codigo_bien: this.codigo_bien,
          extingido_cautelado: this.extingido_cautelado,
          detalleFactura: this.items_productos,
        })
        .then(() => {
          this.snackbar_text = this.$t("snackbar-t14");
          this.snackbar = true;
          this.cerrarDialog();
          this.listarFacturas();
        })
        .catch(() => {
          this.snackbar_text = this.$t("snackbar-t13");
          this.snackbar = true;
        });
    },
    async actualizarBlocs(estatus) {
      await axios
        .put("api/DetallesEmpresas/ActualizarBlob", {
          id_empresa: this.$store.state.emp.id_empresa,
          blob_restante: estatus,
          blob_sumados: estatus,
        })
        .then(() => {
          return;
        });
    },
    confirmarAnularDocumento() {
      this.dialog_confirmar_anular = true;
    },
    async anularFactura() {
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: "INV",
          idFactura: this.id_factura,
          ambiente: await this.obtenerAmbiente(),
        })
        .then(() => {
          this.dialog_confirmar_anular = false;
          this.cerrarDialog();
          this.snackbar_text = this.$t("snackbar-t15");
          this.snackbar = true;
          this.listarFacturas();
        })
        .catch(() => {
          this.snackbar_text = this.$t("snackbar-t1");
          this.snackbar = true;
        });
    },
    listarDetallesfactura() {
      axios
        .get("api/Detallesfacturas/Listar/" + this.id_factura)
        .then((response) => {
          //console.log(response.data);
          this.items_productos = response.data;
        });
    },
    limpiarCamposProductos() {
      this.cantidad = 1;
      this.producto = "";
      this.descripcion = "";
      this.comprovante_pedido = "";
      this.precio = 0;
      this.descuento_prod = 0;
      this.total = 0;
    },
    limpiarCalculosCabecera() {
      this.otros_cargos = 0;
      this.anticipo = 0;
      this.sub_total = 0;
      this.descuento = 0;
      this.gravadas = 0;
      this.iva = 0;
      this.exentas = 0;
      this.no_sujetas = 0;
      this.retencion = 0;
      this.percepcion = 0;
      this.total_operacion = 0;
      this.total_pagar = 0;
    },
    cerrarDialog() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.id_tipo_doc_fiscal = 0;
      this.numero_control = "DTE-00-00000000-000000000000000";
      this.fecha_hora = "";
      this.codigo_generacion = "";
      this.sello_recepcion = "";
      this.fecha_recepcion = "";
      this.tipo_doc_fiscal = "";
      this.tipo_pago = "CONTADO";
      this.id_cliente = 0;
      this.cliente = "";
      this.nombre = "";
      this.registro = "";
      this.identifiador = "";
      this.telefono = "";
      this.tipo = "";
      this.cliente_exento = "";
      this.cliente_retencion = "";
      this.cliente_percepcion = "";
      this.cliente_tamaño = "";
      this.cantidad = 1;
      this.producto = "";
      this.descripcion = "";
      this.precio = 0;
      this.descuento = 0;
      this.total = 0;
      this.items_productos = [];
      this.otros_cargos = 0;
      this.anticipo = 0;
      this.sub_total = 0;
      this.gravadas = 0;
      this.iva = 0;
      this.exentas = 0;
      this.no_sujetas = 0;
      this.retencion = 0;
      this.percepcion = 0;
      this.total_operacion = 0;
      this.total_pagar = 0;
      this.id_detalle_factura = 0;
      this.cont_prod = 0;
      this.flag_new_edit = 1;
      this.codigo_bien = "";
      this.extingido_cautelado = false;
      this.items_tipo_doc_ncr_ndb = [];
      this.resolucion_invalidacion = null;
    },
    async obtenerCorrelativoTipoDocCSV(id) {
      return await (
        await axios.get(
          "api/ConfiFacturas/ListarSeleccionado/" +
            id +
            "/" +
            this.$store.state.emp.id_empresa
        )
      ).data.correlativo;
    },
    async obtenerSucursalCsv(cod) {
      return (
        await axios.get(
          "api/Sucursales/ListarXCodMH/" +
            this.$store.state.emp.id_empresa +
            "/" +
            cod
        )
      ).data[0].id_sucursal;
    },
    async obtenerTipoDocCsv(cod) {
      return (await axios.get("api/TipoDocFiscales/ListarXCod_MH/" + cod))
        .data[0];
    },
    listarDocSeleccionado() {
      var formato = "DTE-";
      var formato_ceros =
        "-" +
        this.cod_sucursal_mh +
        this.cod_punto_venta_mh +
        "-000000000000000";
      var correlativo_length = "";
      var id = 0;

      if (this.tipo_doc_fiscal.id_tipo_doc_fiscal != undefined) {
        id = this.tipo_doc_fiscal.id_tipo_doc_fiscal;
      } else {
        id = this.id_tipo_doc_fiscal;
      }

      axios
        .get(
          "api/ConfiFacturas/ListarSeleccionado/" +
            id +
            "/" +
            this.$store.state.emp.id_empresa +
            "/" +
            this.sucursal +
            "/" +
            this.punto_venta
        )
        .then((response) => {
          //console.log(response.data);
          this.items_tipo_doc_fiscal = response.data;

          correlativo_length = response.data[0].correlativo.toString().length;

          formato_ceros = formato_ceros.substring(
            0,
            formato_ceros.length - correlativo_length
          );

          this.numero_control = formato
            .concat(response.data[0].cod_mh_doc_fiscal)
            .concat(formato_ceros)
            .concat(response.data[0].correlativo);
        });
    },
    incrementarCorrelativoTipoDocCSV(tipo_doc_fiscal) {
      axios
        .put("api/ConfiFacturas/IncrementarCSV", {
          id_tipo_doc_fiscal: tipo_doc_fiscal,
          id_empresa: this.$store.state.emp.id_empresa,
          valor: Number(this.contador_tipo_doc_fiscal) + 1,
        })
        .then(() => {
          this.cerrarDialog();
          this.listarFacturas();
        });
    },
    incrementarCorrelativoTipoDoc() {
      axios
        .put("api/ConfiFacturas/Incrementar", {
          id_confi_factura: this.tipo_doc_fiscal.id_confi_factura,
          id_empresa: this.$store.state.emp.id_empresa,
          valor: Number(this.tipo_doc_fiscal.correlativo) + 1,
        })
        .then(() => {
          this.cerrarDialog();
          this.listarFacturas();
        });
    },
    formatoFecha(item) {
      return settings.metodos.formatoFechaHora(item);
    },
    listarCCF() {
      if (this.id_cliente <= 0) {
        this.snackbar_text = this.$t("snackbar-t16");
        this.snackbar = true;
        return;
      }

      axios
        .get(
          "api/Facturas/ListarParaNcrNdb/" +
            this.$store.state.emp.id_empresa +
            "/" +
            this.id_cliente
        )
        .then((response) => {
          this.items_ccf = response.data;

          this.dialog_tabla_CCF = true;
        });

      if (this.id_factura > 0) {
        axios
          .get(
            "api/DetalleNDB_NCR/Listar/" +
              this.id_factura +
              "/" +
              this.$store.state.emp.id_empresa
          )
          .then((response) => {
            this.lista_nrc_ndb_guardados = response.data;
          });
      }
    },
    listarServiciosDocNCR(item) {
      var format_date_now = settings.metodos.formatoFecha(new Date());
      var format_date_ccf = settings.metodos.formatoFecha(item.fecha);

      var date_now = new Date(format_date_now);
      var date_ccf = new Date(format_date_ccf);

      var milliseconds = Math.abs(date_now - date_ccf);
      var days = Math.ceil(milliseconds / (1000 * 60 * 60 * 24));
      if (days > 120) {
        this.snackbar_text = this.$t("snackbar-t17");
        this.snackbar = true;
        return;
      }

      axios
        .get("api/DetallesFacturas/Listar/" + item.id_factura)
        .then((response) => {
          this.items_detalles_fac = response.data;

          this.dialog_tabla_detalles_fac = true;
        });
    },
    agregarServiciosDocNCR() {
      this.limpiarCalculosCabecera();
      for (var i = 0; i < this.items_productos.length; i++) {
        if (this.cliente_exento) {
          this.calculoExento(this.items_productos[i].total);
          return;
        }

        if (this.items_productos[i].exento) {
          this.calculoExento(this.items_productos[i].total);
          continue;
        }
        if (this.items_productos[i].no_sujeto) {
          this.calculoNoSujeto();
          continue;
        }

        //calculo descuento
        this.monto_descuento = 0;
        this.monto_descuento =
          Number(this.items_productos[i].cantidad) *
          Number(this.items_productos[i].precio) *
          (Number(this.items_productos[i].descuento) / 100);
        this.descuento = Number(this.descuento) + Number(this.monto_descuento);

        if (this.tipo_doc_fiscal.cod_doc_fiscal == "FAC") {
          if (this.cliente_retencion) {
            if (this.items_productos[i].total >= 100) {
              var sin_iva = (this.items_productos[i].total / 1.13).toFixed(2);
              this.retencion = (
                Number(this.retencion) +
                sin_iva * 0.01
              ).toFixed(2);
            }
          }
        } else {
          if (this.cliente_retencion) {
            if (this.items_productos[i].total >= 100) {
              this.retencion = (
                Number(this.retencion) +
                Number(this.items_productos[i].total) * Number(0.01)
              ).toFixed(2);
            }
          }
        }

        if (this.cliente_percepcion) {
          if (this.items_productos[i].total >= 100) {
            this.percepcion = (
              Number(this.items_productos[i].total) * Number(0.01)
            ).toFixed(2);
          }
        }

        this.sumarSubTotales(this.items_productos[i].total);
        this.calculoGravadas(this.sub_total, this.descuento);

        //calculo iva
        if (
          this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NCR" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
        ) {
          this.calculoIva(this.gravadas);
        }
      }

      this.dialog_tabla_detalles_fac = false;
    },
    colorTablaCCF(item) {
      if (this.flag_new_edit == 1) {
        return "";
      } else {
        var index = this.lista_nrc_ndb_guardados.findIndex(
          (i) => i.id_factura_relacionado == item.id_factura
        );
        if (index > -1) {
          return "green";
        }
      }
    },
    colorTablaDetalles(item) {
      if (this.flag_new_edit == 1) {
        return "white";
      } else {
        var index = this.items_productos.findIndex(
          (i) => i.id_detalle_factura_ncr == item.id_detalle_factura
        );
        if (index > -1) {
          return "green";
        }
      }
    },
    fechaLimiteDebitoCredito(obj) {
      var format_date_now = settings.metodos.formatoFecha(new Date());
      var format_date_ccf = settings.metodos.formatoFecha(obj.fecha);

      var date_now = new Date(format_date_now);
      var date_ccf = new Date(format_date_ccf);

      var milliseconds = Math.abs(date_now - date_ccf);
      var days = Math.ceil(milliseconds / (1000 * 60 * 60 * 24));
      if (days > 90) {
        return true;
      } else {
        return false;
      }
    },
    eliminarFactura() {
      this.dialog_eliminar_factura = true;
    },
    confirmarEliminarFactura() {
      this.loading_eliminar_factura = true;
      axios
        .delete("api/Facturas/Eliminar/" + this.id_factura)
        .then(async () => {
          this.snackbar_text = this.$t("snackbar-t18");
          this.snackbar = true;
          this.dialog_eliminar_factura = false;
          await this.actualizarBlocs("eliminar");
          this.cerrarDialog();
          this.listarFacturas();
          this.loading_eliminar_factura = false;
        })
        .catch(() => {
          this.snackbar_text = this.$t("snackbar-t18");
          this.snackbar = true;
          this.loading_eliminar_factura = false;
        });
    },
    alerta(icon, mensaje) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: true,
        timer: 0,
        width: 800,
      });

      Toast.fire({
        icon: icon,
        title: mensaje,
      });
    },
  },
};
</script>

<style>
#myPDF {
  width: 100%;
  height: 100%;
}
</style>